import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import PostSurgicalCare from "../pages/services/post-surgical-care/page";
import ChronicDiseaseManagement from "../pages/services/chronic-disease-management/page";
import TransitionalCare from "../pages/services/transitional-care/page";
import SkilledNursing from "../pages/services/skilled-nursing/page";
import PhysicalTherapy from "../pages/services/physical-therapy/page";
import OccupationalTherapy from "../pages/services/occupational-therapy/page";
import SpeechTherapy from "../pages/services/speech-therapy/page";
import MedicalSocialServices from "../pages/services/medical-social-services/page";
import HomeHealthAide from "../pages/services/home-health-aide/page";
import Careers from "../pages/careers/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/services/skilled-nursing", element: <SkilledNursing /> },
  { path: "/services/physical-therapy", element: <PhysicalTherapy /> },
  { path: "/services/occupational-therapy", element: <OccupationalTherapy /> },
  { path: "/services/speech-therapy", element: <SpeechTherapy /> },
  { path: "/services/medical-social-services", element: <MedicalSocialServices /> },
  { path: "/services/home-health-aide", element: <HomeHealthAide /> },
  { path: "/services/post-surgical-care", element: <PostSurgicalCare /> },
  { path: "/services/chronic-disease-management", element: <ChronicDiseaseManagement /> },
  { path: "/services/transitional-care", element: <TransitionalCare /> },
  { path: "/careers", element: <Careers /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
